import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import StaticBarModel from "../../models/static-bar";

export default class StaticBarRepository extends BaseRepository {
  static modelClass = StaticBarModel;
  modelName = "static-bar";

  async query(caseId) {
    return await super.query({
      urlPath: `case/${caseId}/static_bar/`,
    });
  }
}
